import { useNavigate } from "react-router-dom";
import usePageTitle from "../hooks/usePageTitle";
import { PageShell, GlassCard, Button } from "../components/ui";

export default function NotFoundPage() {
  usePageTitle("Página não encontrada");
  const navigate = useNavigate();

  return (
    <PageShell kicker="404" title="Página não encontrada" subtitle="O endereço não existe ou foi movido.">
      <GlassCard className="p-8 sm:p-10 max-w-lg mx-auto text-center">
        <p className="text-slate-600 dark:text-slate-400 mb-6">
          Verifique o URL ou regresse ao painel para continuar.
        </p>
        <div className="flex flex-wrap gap-3 justify-center">
          <Button type="button" onClick={() => navigate("/dashboard")}>
            Ir para o dashboard
          </Button>
          <Button variant="secondary" type="button" onClick={() => navigate(-1)}>
            Voltar atrás
          </Button>
          <Button variant="ghost" type="button" onClick={() => navigate("/login")}>
            Iniciar sessão
          </Button>
        </div>
      </GlassCard>
    </PageShell>
  );
}
